import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CognitoService } from '../../services/cognito.service';
import { AuthService } from '../../services/auth.service';
import { QRCodeModule } from 'angularx-qrcode';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgOtpInputModule } from 'ng-otp-input';
import { Token } from '../../models/token';
import { AuthError } from 'aws-amplify/auth';
import { NotificationService } from '../../services/notification.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-mfa',
  standalone: true,
  imports: [QRCodeModule, CommonModule, NgOtpInputModule],
  templateUrl: './mfa.component.html',
})
export class MfaComponent implements OnInit {

  form = new FormGroup({
    code: new FormControl("", [Validators.required]),
  });

  public stringQrCode: string;
  wrongcode = false;
  registerInfo: any;
  loading = false;

  constructor(public router: Router, public cognitoService: CognitoService, private traslateService: TranslateService,
    public authService: AuthService, private notificationService: NotificationService) {
    this.stringQrCode = '';
  }

  ngOnInit(): void {
    if (localStorage.getItem("uri") == undefined) {
      this.stringQrCode = "https://totaldoc.com";
    } else {
      this.stringQrCode = localStorage.getItem("uri")!;
    }
  }

  onOtpChange(otp: any) {
    this.wrongcode = false;
    this.form.controls['code'].setValue(otp);
  }

  async next() {
    if (this.form.invalid || this.form.controls['code'].value!.length < 6) {
      const title = await this.traslateService.get('NOTIFI.titleWarning').toPromise();
      const detail = await this.traslateService.get(`ERRORS.errorCodeVerification`).toPromise();
      this.notificationService.showWarning(title, detail)
      return;
    }
    this.loading = true;
    try {
      await this.cognitoService.handleSingInConfirmation(this.form.controls['code'].value!);
      const { username, userId, signInDetails } = await this.cognitoService.currentAuthenticatedUser();
      const accessTokenCognito = await this.cognitoService.returnAccesToken();
      localStorage.setItem("Authorization", accessTokenCognito!.toString());
      this.authService.updateUser(signInDetails?.loginId!, userId).subscribe(
        response => {
          console.log('User updated:', response);
        },
        async (error) => {
          const errorDetail = error?.error?.detailCode || 'Error';
          const title = await this.traslateService.get('NOTIFI.titleError').toPromise();
          const detail = await this.traslateService.get(`ERRORS.${errorDetail}`).toPromise();
          this.notificationService.showError(title, detail)
        }
      );
      const token: Token = {
        username: signInDetails?.loginId!,
        accessToken: String(accessTokenCognito)
      }
      const response = await this.insertTokenAsync(token);
      localStorage.setItem("userId", response.userId);
      const title = await this.traslateService.get('NOTIFI.titleSuccess').toPromise();
      const detail = await this.traslateService.get(`NOTIFI.associatedAccount`).toPromise();
      this.notificationService.showStandard(title, detail)
      this.router.navigateByUrl('');
    } catch (error) {
      if (error instanceof AuthError) {
        switch (error.name) {
          case "EnableSoftwareTokenMFAException":
            const title = await this.traslateService.get('NOTIFI.titleError').toPromise();
            const detail = await this.traslateService.get(`ERRORS.errorCodeInvalid`).toPromise();
            this.notificationService.showWarning(title, detail)
            break
          default:
            const detailB = await this.traslateService.get(`ERRORS.Error`).toPromise();
            this.notificationService.showError(title, detailB)
            break
        }
      } else {
        const title = await this.traslateService.get('NOTIFI.titleError').toPromise();
        const detailB = await this.traslateService.get(`ERRORS.Error`).toPromise();
        this.notificationService.showError(title, detailB)
      }
      this.loading = false;
    }
  }

  // Método para convertir el servicio en una Promesa
  insertTokenAsync(token: Token): Promise<any> {
    return new Promise((resolve, reject) => {
      this.authService.insertToken(token).subscribe(
        response => resolve(response),
        error => reject(error)
      );
    });
  }

}
